import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { dmCapHangDuongBo, dmCongTrinhCapDien, dmLoaiDuong, dmLoaiKhongGianCayXanh, dmLoaiQuyHoach, dmLoaiTramTTTC, dmTrangThaiQuyHoach } from "src/app/quan-tri/Constants/Constants";

@Component({
  selector: "app-feature-info",
  templateUrl: "./feature-info.component.html",
  styleUrls: ["./feature-info.component.scss"],
})
export class FeatureInfoComponent implements OnInit, OnChanges {
  @Input() tableName: string;
  @Input() featureInfo: any;
  @Output() onClose = new EventEmitter<any>();
  @Output() fitParcelBound = new EventEmitter<any>();
  @Output() showImage = new EventEmitter<any>();
  @Output() showVideo = new EventEmitter<any>();
  featureProps: any[] = [];
  soLuongThua: number = 0;
  dsThua: any[] = [];
  showThuaDat: boolean = false;
  isLoadingBlock: boolean = false;
  images: any = [];
  imageIndex: number = 0;
  postImages: any = [
    {
      id: 1,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-1.jpg",
    },
    {
      id: 2,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-2.jpg",
    },
    {
      id: 3,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-3.jpg",
    },
    {
      id: 4,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-4.jpg",
    },
    {
      id: 5,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-4.jpg",
    },
    {
      id: 6,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-6.jpg",
    },
    {
      id: 7,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-7.jpg",
    },
    {
      id: 7,
      src: "http://45.118.146.215:72/assets/cayxanh/CX-8.jpg",
    },
  ];
  carouselOption: OwlOptions = {
    items: 1,
    loop: false,
    margin: 0,
    nav: true,
    dots: true,
    responsive: {
      680: {
        items: 1,
      },
    },
  };
  constructor() { }

  ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges): void {
    if ("featureInfo" in changes) {
      this.isLoadingBlock = true;
      this.chuanHoaDuLieuThuocTinh(this.featureInfo);
      setTimeout(() => {
        this.isLoadingBlock = false;
      }, 300);
    }
  }
  close() {
    this.onClose.emit();
  }

  chuanHoaDuLieuThuocTinh(props: any) {
    const featureProps = [];
    Object.keys(props).forEach((key) => {
      // let key = prop.Key;
      let value = props[key];
      if (
        key &&
        key !== "geom" &&
        key !== "objectid" &&
        key !== "s_geom" &&
        key !== "object_id" &&
        key !== "maid" &&
        key !== "s_xdaidien" &&
        key !== "s_ydaidien" &&
        key !== "madoituong" &&
        key !== "malienket" &&
        key !== "xdaidien" &&
        key !== "ydaidien" &&
        key !== "guid" &&
        key !== "parentguid" &&
        key !== "shape_length" &&
        key !== "shape_leng" &&
        key !== "mucdichsud" &&
        key !== "shape_area"
      ) {
        if (key === "kehoachsdd") key = "Kế hoạch sử dụng đất";
        else if (key === "matinh") key = "Mã tỉnh";
        else if (key === "mahuyen") key = "Mã huyện";
        else if (key === "tenhuyen") key = "Tên huyện";
        else if (key === "tenvungquy") key = "Tên vùng quy hoạch";
        else if (key === "mucdichsud") key = "Mục đích sử dụng";
        else if (key === "nhan_mdsd") key = "Mục đích sử dụng";
        else if (key === "namquyhoac") key = "Năm quy hoạch";
        else if (key === "mahoso") key = "Mã hồ sơ";
        else if (key === "chucnang") key = "Chức năng";
        else if (key === "ttqh") key = "Thông tin quy hoạch";
        else if (key === "ghichu") key = "Ghi chú";
        else if (key === "maxa") key = "Mã xã";
        else if (key === "tenxa") key = "Tên xã";
        else if (key === "chieucao") key = "Chiều cao";
        else if (key === "donviquanl") key = "Đơn vị quản lý";
        else if (key === "hientrang") key = "Hiện trạng";
        else if (key === "phanloai") key = "Phân loại";
        else if (key === "tengoi") key = "Tên gọi";
        else if (key === "tenxa") key = "Tên xã";
        else if (key.indexOf("mahoso") !== -1) key = "Mã hồ sơ";
        else if (key.indexOf("madoituong") != -1) key = "Mã đối tượng";
        else if (key.indexOf("malienket") != -1) key = "Mã liên kết";
        // else if (key.indexOf("loaidoituong") != -1) key = "Loại đối tượng";
        else if (key.indexOf("tendoituong") != -1) key = "Tên đối tượng";
        else if (key.indexOf("kyhieu") != -1) key = "Ký hiệu";
        else if (key.indexOf("congsuat") != -1) key = "Công suất";
        else if (key.indexOf("vitri") != -1) key = "Vị trí";
        else if (key === "gtl_tenduong") key = "Tên đường";
        else if (key === "ttllp_tentram") key = "Tên trạm";

        else if (key === "ttllp_loaitramtttc") {
          key = "Loại trạm";
          value = dmLoaiTramTTTC[value]
        }
        else if (key === "gtl_caphangduongbo") {
          key = "Cấp hạng đường bộ";
          value = dmCapHangDuongBo[value]
        }
        else if (key === "gtl_loaiduong") {
          key = "Loại đường";
          value = dmLoaiDuong[value]
        }
        else if (key.indexOf("chieudai") != -1) key = "Chiều dài";
        else if (key === "gtl_kyhieumatcat") key = "Ký hiệu mặt cắt";
        else if (key.indexOf("loaiqh") != -1) {
          key = "Loại quy hoạch";
          value = dmLoaiQuyHoach[value];
        }
        else if (key.indexOf("ctcdp_loaidoituong") != -1) {
          key = "Loại đối tượng";
          value = dmCongTrinhCapDien[value];
        }

        else if (key === "cgdd_mucdichxacdinhcgdd") key = "Mục đích xác định";
        else if (key === "kgmn_loaimatnuoc") key = "Loại mặt nước";
        else if (key === "kgmn_dientich") key = "Diện tích ";

        else if (key === "kgcx_loaikhonggiancayxanh") {
          key = "Loại không gian cây xanh";
          value = dmLoaiKhongGianCayXanh[value];
        }
        else if (key === "kgcx_dientich") key = "Diện tích cây xanh";

        else if (key === "tnm_loaicongthoatnuoc") key = "Loại công thoát nước";
        else if (key === "tnm_duongkinh") key = "Đường kính";
        else if (key === "tnm_chieudai_banve") key = "Chiều dài bản vẽ";
        else if (key.indexOf("trangthaiquyhoach") != -1) {
          key = "Trạng thái quy hoạch ";
          value = dmTrangThaiQuyHoach[value];
        }
        else if (key === "tnm_ghichu") key = "Ghi chú ";


        else if (key === "mlcd_dienthe") key = "Điện thế";
        else if (key === "mlcd_loaiduongday") key = "Loại đường dây";
        else if (key === "mlcd_ghichu") key = "Ghi chú ";

        else if (key === "tnt_mahoso") key = "Mã hồ sơ ";
        else if (key === "tnt_madoituong") key = "Mã đối tượng ";
        else if (key === "tnt_malienket") key = "Mã liên kết ";
        else if (key === "tnt_loaicongtrinhthoatnuoc") key = "Loại công trình thoát nước";
        else if (key === "tnt_duongkinh") key = "Đường kính ";
        else if (key === "tnt_chieudai_banve") key = "Chiều dài bản vẽ ";
        else if (key === "tnt_ghichu") key = "Ghi chú ";

        else if (key === "ttll_mahoso") key = "Mã hồ sơ ";
        else if (key === "ttll_madoituong") key = "Mã đối tượng ";
        else if (key === "ttll_malienket") key = "Mã liên kết ";
        else if (key === "ttll_loaiduongday") key = "Loại đường dây ";
        else if (key === "ttll_tenduongday") key = "Tên đường dây ";

        else if (key === "ttll_mahoso") key = "Mã hồ sơ ";
        else if (key === "ttll_madoituong") key = "Mã đối tượng ";
        else if (key === "ttll_malienket") key = "Mã liên kết ";
        else if (key === "ttll_loaiduongday") key = "Loại đường dây ";
        else if (key === "ttll_tenduongday") key = "Tên đường dây ";

        else if (key === "daqh_tyle") key = "Tỷ lệ quy hoạch ";
        else if (key === "daqh_loaiquyhoach") key = "Loại quy hoạch ";
        else if (key === "daqh_tendoan") key = "Tên đồ án ";
        else if (key === "daqh_tinhtrangphaply") key = "Tình trạng pháp lý ";
        else if (key === "daqh_quyhoachdieuchinh") key = "Quy hoạch điều chỉnh ";
        else if (key === "daqh_diadiemquyhoach") key = "Địa điểm quy hoạch ";
        else if (key === "daqh_matinh") key = "Mã tỉnh ";
        else if (key === "daqh_tentinh") key = "Tên tỉnh ";
        else if (key === "daqh_mahuyen") key = "Mã huyện ";
        else if (key === "daqh_tenhuyen") key = "Tên huyện ";
        else if (key === "daqh_maxa") key = "Mã xã ";
        else if (key === "daqh_tenxa") key = "Tên xã ";
        else if (key === "daqh_dientich") key = "Diện tích (m²) ";
        else if (key === "daqh_dientich_bando") key = "Diện tích bản đồ (m²) ";
        else if (key === "daqh_danso") key = "Dân số ";
        else if (key === "daqh_soquyetdinh") key = "Số quyết định ";
        else if (key === "daqh_ngayquyetdinh") key = "Ngày quyết định ";
        else if (key === "daqh_donvipheduyet") key = "Đơn vị phê duyệt ";
        else if (key === "daqh_tenbanve") key = "Tên bản vẽ ";
        else if (key === "daqh_tenthumuc") key = "Tên thư mục ";
        else if (key === "daqh_duongdanthumuc") key = "Đường dẫn thư mục ";
        else if (key === "daqh_loaibanve") key = "Loại bản vẽ ";
        else if (key === "daqh_mabanve") key = "Mã bản vẽ ";

        else if (key === "noqh_kyhieu") key = "Ký hiệu ";
        else if (key === "noqh_dientich") key = "Diện tích (m²) ";
        else if (key === "noqh_dientich_bando") key = "Diện tích bản đồ (m²) ";
        else if (key === "noqh_dientich_ha") key = "Diện tích (ha) ";
        else if (key === "noqh_matdoxdtoida") key = "Mật độ XD tối đa (%) ";
        else if (key === "noqh_tangcaotoida") key = "Tầng cao tối đa ";
        else if (key === "noqh_hesosdd") key = "Hệ số SDĐ ";
        else if (key === "noqh_chucnangsdd") key = "Chức năng SDĐ ";
        else if (key === "noqh_planppname") key = "Tên chức năng quy hoạch ";
        else if (key === "noqh_chuyendoichucnangsdd") key = "Chuyển đổi chức năng SDĐ ";
        else if (key === "noqh_makhuqh") key = "Mã khu quy hoạch ";
        else if (key === "noqh_tinhtrang") key = "Trạng thái quy hoạch ";
        else if (key === "noqh_loaiquyhoach") key = "Loại quy hoạch ";
        else if (key === "noqh_tenbanve") key = "Tên bản vẽ ";
        else if (key === "noqh_tenthumuc") key = "Tên thư mục ";
        else if (key === "noqh_duongdanthumuc") key = "Đường dẫn thư mục ";
        else if (key === "noqh_loaibanve") key = "Loại bản vẽ ";
        else if (key === "noqh_mabanve") key = "Mã bản vẽ ";
        else if (key === "noqh_layer") key = "Lớp dữ liệu ";
        else if (key === "noqh_color") key = "Màu sắc ";


        featureProps.push({
          key: key,
          value: value.toString() == "[object Object]" ? "" : value,
        });
      }
    });

    this.featureProps = featureProps;
    // return featureProps;
  }
  trackFunc(index: any, item: any): string {
    return index; // item.id;
  }
  openImage(id) {
    // console.log('open image', id)
    // this.images.push('/assets/cayxanh/' + id + '.jpg'
    // )
    this.showImage.emit(id);
  }
  openVideo(id) {
    this.showVideo.emit(id);
  }
}
